import React, {useRef} from 'react';
import config from 'src/config/config.json';

// Modules
import type {GraphQLClient} from '@deezer/graphql-client';
import {
	createClient as createGraphQLClient,
	GraphQLProvider as DeezerGraphQLProvider,
} from '@deezer/graphql-client';
import {defaultDataIdFromObject} from '@deezer/graphql-client/core';
import {useAuth} from './AuthProvider';

interface Params {
	locale?: string;
	offline?: boolean;
}

import introspectionResult from '@graphql/introspection.gen';
import {useURLParams} from './URLParamsProvider';
import {useRouter} from 'next/router';

const GraphQLProvider: React.FC<React.PropsWithChildren<Params>> = ({
	offline = false,
	children,
}) => {
	const {campaign} = useURLParams();
	const {locale} = useRouter();
	const uri = `https://${config.host_pipe}/api`;

	const client = useRef<GraphQLClient>();
	const [, {getToken, invalidateCurrentToken}] = useAuth();

	if (!client.current) {
		client.current = createGraphQLClient({
			uri,
			getLocale: () => (locale === 'pt' ? 'pt-PT' : locale) || 'en-US',
			getToken,
			onTokenInvalid: invalidateCurrentToken,
			connectToDevTools: true, //process.env.NODE_ENV === 'development',
			disableOffline: !offline,
			possibleTypes: introspectionResult.possibleTypes,
			dataIdFromObject(responseObject) {
				return campaign.includes('debug') && responseObject.__typename == 'Card'
					? `Card:${responseObject.id}:${JSON.stringify(responseObject)}`
					: defaultDataIdFromObject(responseObject);
			},
		});
	}

	return (
		<DeezerGraphQLProvider client={client.current}>
			{children}
		</DeezerGraphQLProvider>
	);
};

export default GraphQLProvider;
